var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrearPublicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15102 4.95H7.82238V6.05H6.15102V7.7H5.03678V6.05H3.36542V4.95H5.03678V3.3H6.15102V4.95ZM11.1651 1.925V7.7L7.82238 11H1.97262C0.914097 11 0.0227051 10.12 0.0227051 9.075V1.925C0.0227051 0.88 0.914097 0 1.97262 0H9.21518C10.2737 0 11.1651 0.88 11.1651 1.925ZM10.0509 2.09C10.0509 1.54 9.60516 1.1 9.04805 1.1H2.13976C1.58264 1.1 1.13694 1.54 1.13694 2.09V8.965C1.13694 9.515 1.58264 9.955 2.13976 9.955H7.26526V9.13C7.26526 8.085 8.15665 7.205 9.21518 7.205H10.0509V2.09Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrearPublicacion);
export default __webpack_public_path__ + "static/media/crearPublicacion.2f9337771f47fc7f3219e425c475b77e.svg";
export { ForwardRef as ReactComponent };